import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase.config';

const MAX_AGE_MS = 30000;
let ownerUid = '';
let cached = null;
let pending = null;
let generation = 0;

export function clearAutomationPackageCache() {
  ownerUid = '';
  cached = null;
  pending = null;
  generation += 1;
}

export function cachedAutomationPackages(uid) {
  return uid && ownerUid === uid ? cached?.packages ?? null : null;
}

export function loadAutomationPackages(uid, { refresh = false } = {}) {
  if (!uid) return Promise.resolve([]);
  if (ownerUid !== uid) {
    clearAutomationPackageCache();
    ownerUid = uid;
  }
  if (pending) return pending;
  if (!refresh && cached && Date.now() - cached.loadedAt < MAX_AGE_MS) return Promise.resolve(cached.packages);
  const requestGeneration = generation;
  const request = httpsCallable(functions, 'listCustomerAutomationPackages')()
    .then((response) => {
      const packages = response.data?.packages || [];
      if (generation === requestGeneration) cached = { packages, loadedAt: Date.now() };
      return packages;
    })
    .finally(() => {
      if (generation === requestGeneration) pending = null;
    });
  pending = request;
  return request;
}
